import { render, staticRenderFns } from "./TenancySubscriptionPlanPreview.vue?vue&type=template&id=1b9062bc&scoped=true&"
import script from "./TenancySubscriptionPlanPreview.vue?vue&type=script&lang=js&"
export * from "./TenancySubscriptionPlanPreview.vue?vue&type=script&lang=js&"
import style0 from "./TenancySubscriptionPlanPreview.vue?vue&type=style&index=0&id=1b9062bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9062bc",
  null
  
)

export default component.exports